var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartG10 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9D9D9D",
  strokeMiterlimit: 10,
  d: "M5.5 9.285 1.565 5.267l-.319-.326A2.63 2.63 0 0 1 .5 3.1c0-.692.27-1.355.746-1.841A2.5 2.5 0 0 1 3.036.5c.668 0 1.312.271 1.788.758l.319.325.357.365.357-.365.32-.325A2.5 2.5 0 0 1 7.964.5c.669 0 1.313.271 1.789.758.476.486.746 1.149.746 1.841 0 .693-.27 1.356-.746 1.842l-.319.326z"
})));
export default SvgIconHeartG10;